import DateFnsUtils from '@date-io/date-fns';
import {Trans} from '@lingui/macro';
import {Button, Divider, LinearProgress} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {Title} from 'components/forms';
import useRole from 'components/GenericsHooks/useRoles';
import CustomAlert from 'components/grid-dx/alert';
import {profGral} from 'constants/url';
import {i18n2} from 'features/i18n/i18n';
import {FastField, Field, Form, Formik} from 'formik';
import {TextField} from 'formik-material-ui';
import authFetch from 'helpers/requests';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {profGralSchema} from './../model/ProfGral';
import AutocompleteMultiple from './../../consult/component/form/multipleSelect';
import getProfSpacs from '../requests/getProfSpacs';
import getProfGralById from '../requests/getProfGralSpacsById';

const EditProfGralPopup = ({row, open, setOpen, handleClose, refresh}) => {
  const role = useRole();
  const user = useSelector((state) => state.authentication.user.name);
  const token = useSelector((state) => state.authentication.user.token);
  const [message, setMessage] = useState({
    text: '',
    open: false,
    successful: false,
  });
  const [profSpacs, setProfSpacs] = useState([]);
  const [selectedProfSpacs, setSelectedProfSpacs] = useState([]);
  const [hasLoaded, setHasLoaded] = useState(false);

  const submit = async (values) => {
    const method = 'PUT';
    let info = {...values, profSpacs: selectedProfSpacs, user: user, rol: role};
    info = JSON.stringify(JSON.stringify(info));
    try {
      const response = await authFetch(
        `${profGral}/${row.iD_ProfGral}`,
        {
          method: method,
          headers: {
            'Content-Type': 'application/json',
          },
          body: info,
        },
        token,
      );
      if (response.ok) {
        setMessage({
          text: i18n2._('Perfil editado correctamente'),
          open: true,
          successful: true,
        });
        refresh();
      } else {
        response
          .text()
          .then((message) =>
            setMessage({text: message, open: true, successful: false}),
          );
        setMessage({text: response.message, open: true});
      }
      // setOpen(false);
    } catch (error) {
      return console.log(error);
    }
  };

  useEffect(() => {
    getProfSpacs(token).then((data) => {
      if (data != null) {
        setProfSpacs(data.data);
      }
    });

    getProfGralById(token, row.iD_ProfGral).then((data) => {
      if (data !== null) {
        setSelectedProfSpacs(data.profSpacs);
        setHasLoaded(true);
      }
    });
  }, [token, row]);

  return hasLoaded ? (
    <>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        scroll="body"
        maxWidth="md"
        fullWidth={true}
        onClose={() => handleClose()}>
        <Title
          onClose={handleClose}
          title={`${i18n2._('Editar')} ${i18n2._('Profile-General')}`}
        />
        <Divider />
        <DialogContent>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Formik
              initialValues={{
                description: row.description,
                profSpacs: selectedProfSpacs,
                reason: '',
                pass: '',
                user: user,
              }}
              onSubmit={submit}
              validationSchema={profGralSchema(true, true)}>
              {(formikProps) => {
                return (
                  <Form>
                    <Grid container spacing={2}>
                      <Grid item md={6} xs={12}>
                        <Field
                          name="description"
                          required
                          component={TextField}
                          label={i18n2._('Descripción')}
                          fullWidth
                          variant="outlined"
                          error={
                            formikProps.errors['description'] &&
                            formikProps.touched['description']
                          }
                          helperText={
                            formikProps.touched['description'] &&
                            formikProps.errors['description']
                          }
                        />
                      </Grid>
                      <Grid item md={6} xs={6}>
                        <AutocompleteMultiple
                          name="profSpacs"
                          label={i18n2._('ProfSpacs')}
                          changeValue={(val) => {
                            formikProps.setFieldValue('profSpacs', val);
                            setSelectedProfSpacs(val);
                          }}
                          options={profSpacs}
                          defaultValue={selectedProfSpacs}
                          customOptionLabel={(x) =>
                            `${x.spac} - ${x.profileDesc}`
                          }
                          customOptionSelected={(option, value) => {
                            return (
                              option.iD_ProfileSpac === value.iD_ProfileSpac
                            );
                          }}
                          error={
                            Boolean(formikProps.errors['profSpacs']) &&
                            formikProps.touched['profSpacs']
                              ? true
                              : false
                          }
                          helperText={
                            formikProps.touched['profSpacs'] &&
                            formikProps.errors['profSpacs']
                              ? formikProps.errors['profSpacs']
                              : null
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          label={i18n2._('Reason')}
                          name={'reason'}
                          fullWidth
                          variant="outlined"
                          component={TextField}
                          validate={(value) => {
                            let error;
                            if (
                              typeof value !== 'undefined' &&
                              value.length === 0
                            ) {
                              error = i18n2._('Please provide a reason');
                            }
                            return error;
                          }}
                          multiline
                        />
                      </Grid>
                      <Grid item sm={6} xs={12} style={{padding: 20}}>
                        <Field
                          label={i18n2._('User')}
                          name={'user'}
                          variant="standard"
                          size="small"
                          fullWidth
                          component={TextField}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled={true}
                        />
                      </Grid>
                      <Grid item sm={6} xs={12} style={{padding: 20}}>
                        <FastField
                          label={i18n2._('Password')}
                          name={'pass'}
                          variant="standard"
                          size="small"
                          fullWidth
                          component={TextField}
                          type="password"
                          validate={(value) => {
                            let error;
                            if (
                              typeof value !== 'undefined' &&
                              value.length === 0
                            ) {
                              error = i18n2._('Please provide a password');
                            }
                            return error;
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      {formikProps.isSubmitting && <LinearProgress />}
                      <Grid item xs={12}>
                        <div style={{float: 'right', marginBottom: '10px'}}>
                          <Button
                            onClick={() => handleClose()}
                            className="red-text">
                            {i18n2._('Cancelar')}
                          </Button>
                          <Button
                            type="submit"
                            disabled={formikProps.isSubmitting}
                            variant="contained"
                            color="primary">
                            <Trans>Confirmar</Trans>
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </MuiPickersUtilsProvider>
        </DialogContent>
        <CustomAlert
          message={message.text}
          ms={1000}
          successful={message.successful}
          handleClose={() => setMessage((prev) => ({...prev, open: false}))}
          open={message.open}
        />
      </Dialog>
    </>
  ) : null;
};

export default EditProfGralPopup;
